import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";

const CongratulationsModal = ({ isOpen, toggle, setIsResultModalOpen }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <div
        style={{
          position: "relative",
          background: "linear-gradient(to right, #e0eafc, #cfdef3)", // Matching gradient background
          borderRadius: "10px",
          padding: "2rem 1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", // Matching font family
        }}
      >
        {/* Custom Close Button */}
        <Button
          type="button"
          onClick={toggle}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            border: "none",
            background: "transparent",
            fontSize: "1.8rem",
            fontWeight: "bold",
            color: "#333",
            cursor: "pointer",
          }}
        >
          ×
        </Button>

        {/* Modal Heading */}
        <h4
          className="text-center mb-3"
          style={{
            fontWeight: "700",
            fontSize: "1.5rem",
            color: "#000080", // Matching heading color
          }}
        >
          🎉 Congratulations! 🎉
        </h4>

        {/* Modal Body */}
        <ModalBody className="text-center">
          <p style={{ fontSize: "1.1rem", color: "#333" }}>
            Thank you for completing the quiz! Check your email to get your{" "}
            <strong style={{ fontWeight: "bold", color: "#000" }}>
              10% discount code.
            </strong>{" "}
          </p>

          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
            <Button
              style={{
                backgroundColor: "#000080", // Matching primary button color
                borderColor: "#000080",
                padding: "0.6rem 1.2rem",
                fontWeight: "600",
                transition: "all 0.3s ease",
                width: "9.5rem",
                height: "2.5rem"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#1a1aff"; // Matching hover effect
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#000080";
              }}
              onClick={() => {
                toggle();
                setIsResultModalOpen(true); // Show the results modal after closing this modal
              }}
            >
              View Results
            </Button>

            <Button
              color="secondary"
              style={{
                padding: "0.6rem 1.2rem",
                fontWeight: "600",
                backgroundColor: "#6c757d", // Matching secondary button color
                borderColor: "#6c757d",
                transition: "all 0.3s ease",
                width: "9.5rem",
                height: "2.5rem"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#5a6268"; // Matching hover effect
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#6c757d";
              }}
              onClick={toggle}
            >
              Close
            </Button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default CongratulationsModal;